<template>
  <div id="app">
    <section class="panda-container">
      <section class="panda-sidebar  is-menu-spread">
        <NavMenu></NavMenu>
      </section>
    </section>
    <section class="panda-body is-body-spread">
      <Header :username="username"></Header>
      <div class="panda-content">
        <router-view></router-view>
      </div>
    </section>
  </div>
</template>

<script>
  import Router from "vue-router";
  import NavMenu from "../components/nav-menu.vue";
  import Header from "../components/header.vue";
  import Home from "../pages/home.vue";
  import Login from "../pages/login";
  import Notpage from "../pages/notpage.vue";
  import Title from "./title.vue";
  import {getStaff} from "@/api/staff.js";
  export default {
    name: "app",
    data() {
      return {
        username: "",
      };
    },
    components: {
      NavMenu,
      Header
 
    },
    created() {

    },
    mounted() {
       this.getRole();
       this.getStaff();
    },
    methods: {
       getRole(){
            const routesBase =  
                  [
                    {
                      path: "/login",
                      name: "Login",
                      component: Login,
                      hidden: true,
                    },
                    {
                      path: "/account/editPassword",
                      hidden: true,
                      component: () => import('../pages/account/editPassword.vue'),
                    },
                    {
                      path: "/home/enterprise",
                      hidden: true,
                      component: () => import('../pages/enterprise.vue'),
                    }, 
                    {
                      path: "/",
                      component: Home,
                      name: "Home",
                      leaf: true,
                      iconCls: 'iconfont icon-shouye',
                      children: [{
                      path: '/home',
                      component: Title,
                      name: '首页',
                      iconCls: 'iconfont icon-shouye'
                      }]
                    },
                    {
                      path: "*",
                      redirect: {
                      path: '/404'
                      },
                      hidden: true,
                    },
                    {
                      path: "/404",
                      name: "错误页面",
                      component: Notpage,
                      hidden: true,
                    },


            ];
            if(localStorage.getItem("menuData")){
         
                let menuData=JSON.parse(localStorage.getItem("menuData"));
                let z=0;
                for(let i in menuData){
                  if(menuData[i]["hidden"]==1){
                      menuData[i]["hidden"]=true;
                    }else{
                      menuData[i]["hidden"]=false;
                    }
                  let menuArray={
                    path: menuData[i]["path"],
                    name: menuData[i]["label"],
                    num: menuData[i]["num"],
                    api: menuData[i]["api"],
                    component: Home,
                    iconCls: menuData[i]["icon"],
                    hidden:menuData[i]["hidden"],
                    children:[],
                  }
                  let children=menuData[i]["children"];
                  for(let j in children){
                      z=z+1;
                      children[j]["key"]=z;
                      let url=children[j]["path"];
                      if(children[j]["engine"]){
                        url=children[j]["engine"]+children[j]["key"]+"/info";
                      }
       
                      let menuRow={
                        name: children[j]["label"],
                        path: children[j]["path"],
                        api: children[j]["api"],
                        num: children[j]["num"], 
                        component: () => import('../pages'+url+'List.vue'),
                      }
                      
                      //console.log(children[j]["path"]+children[j]["key"]);

                      menuArray.children.push(menuRow);
                      let config_hidden_page=children[j]["config_hidden_page"];
                      for(let e in config_hidden_page){

                        if(config_hidden_page[e].id==1){
                          let menuRow={
                            name: config_hidden_page[e]["name"],
                            path: config_hidden_page[e]["path"],
                            hidden: true,
                            component: () => import('../pages'+url+'Detail.vue'),
                          }
                          menuArray.children.push(menuRow);
                        }

                        if(config_hidden_page[e].id==2){
                          let menuRow={
                            name: config_hidden_page[e]["name"],
                            path: config_hidden_page[e]["path"],
                            hidden: true,
                            component: () => import('../pages'+children[j]["path"]+'Edit.vue'),
                          }
                          menuArray.children.push(menuRow);
                        }


                        if(config_hidden_page[e].id==3){
                          let menuRow={
                            name: config_hidden_page[e]["name"],
                            path: config_hidden_page[e]["path"],
                            hidden: true,
                            component: () => import('../pages'+children[j]["path"]+'Edit.vue'),
                          }
                          menuArray.children.push(menuRow);
                        }

                      }

                  }
                  routesBase.push(menuArray);
                }
            }

          const createRouter = () => new Router({
            linkActiveClass: 'active',
            mode: 'hash',
            base: './',
            routes: routesBase
          });
          this.$router.matcher = createRouter().matcher;
          this.$store.dispatch('actUpdateRouteList',routesBase)
       },
       getStaff() {
          let data = {};
          getStaff(data)
            .then((response) => {
              this.loading=false;
              if (response.code == 200) {
                 localStorage.setItem(
                    "name",response.data.name
                  );
                this.username=response.data.name;
              }
            })
            .catch((error) => {
              console.log(error);
            });
       },
    }
  };
</script>
<style>
      html {
        font-size: 100px;
      }

      a {
        text-decoration: none;
      }

      body,
      div,
      html,
      li,
      ol,
      p,
      ul {
        margin: 0;
        padding: 0;
        font-family: PingFangSC-Regular;
        font-weight: 400;
      }

      body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
        color: rgba(0, 0, 0, 0.8);
        background-color: #fff;
        font-size: 12px;
        margin: 0;
        padding: 0;
      }

      .main {
        padding: 0 36px;
        padding-bottom: 134px;
        box-sizing: border-box;
        background-color: white;
      }

      .nav-title-name {
        margin-top: 36px;
        margin-bottom: 22px;
        font-size: 22px;
        color: #303133;
      }

      .page-nav-left .title {
        font-size: 14px;
        font-weight: 600;
      }

      .panda-content {
        /*    display: flex;
        flex-direction: column;
        padding: 0.78rem 20px 0;
        min-width: 1240px;
        height: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        background: #F0F2F5; */

        display: flex;
        flex-direction: column;
        min-width: 960px;
        /*    min-height: calc(100vh - 62px);
        margin-top: 62px; */
        flex-grow: 1;
        height: 100vh;
        overflow: auto;
        box-sizing: border-box;
        overflow-y: auto;
        background: #F0F2F5;
      }

      .el-dialog {
        width: 800px;
      }

      .panda-container,
      .panda-sidebar {
        display: flex;
        flex-direction: column;

      }

      .panda-sidebar {
        position: absolute;
        height: 100vh;
        top: 0;
      }

      .panda-body {
        flex: 1;
        height: 100%;
      }

      .el-submenu .el-menu-item {
        min-width: 160px;
      }

      .panda-sidebar .el-menu-item-group li {
        min-width: 160px;
      }

      a {
        color: #409EFF;
      }


    .top-box{
      margin:10px;
      padding:20px 20px 10px 20px;
      background-color:#fff;
      width:calc(100% - 60px);
    }
    .mid-box{
      margin:10px;
      background-color:#fff;
      width:calc(100% - 20px);
    }
    .el-step__title{
      font-size:12px;
    }
    .detail-box{
      padding:0px 5px 0px 10px;
      background-color:#fff;
      width:calc(100% - 15px);

    }
    .detail-box-main{
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      width:100%;
    }
    .detail-box-main-top{
      width:100%;
    }
    .detail-box-main-left{
      width:70%;
    }
    .detail-box-main-right{
      margin-left:40px;
      width:calc(30% - 40px);
    }
    .detail-box-main-table-warp{
      margin:0px 0px;
    }
    .detail-box-main-table-button-box{
      display:flex;
      justify-content:end;
      padding-bottom:10px;
    }
    .detail-box-main-table-button-box_2{
      display:flex;
      justify-content:space-between;
      padding-bottom:10px;
    }
    .dyButton{
      display:flex;
      justify-content:end;
      margin-top:10px;
    }
    .dy-search-box{
      display:flex;
      justify-content:end;
      margin:10px 0px 10px 10px;
      border-top:1px solid #e1e1e1;
      padding-top:10px;
    }
    .dy-content-box{
      padding:0px 20px;
    }
    .user-box{
      display:flex;
      align-items:center;
      padding:0px 0px;
    }
    .user-box-name{
      height:25px;
      line-height:25px;
      font-size:14px;
      padding:0px 10px 
    }
    .form-main{
      overflow-y:scroll;
      max-height:500px;
    }
    .timeline-box{
      display:flex;
      flex-direction: column;
      background-color:#f5f5f5;
      padding:2px 10px;
    }
    .timeline-content-1{
      font-size:14px;
      padding:10px 0px 0px 0px;
    } 
    .timeline-content-2{
      display:flex;
      justify-content:space-between;
      align-items: center;
      font-size:12px;
      color:#aaa;
      padding:5px 0px 5px 0px;
    }
    .timeline-content-2-1{
      display:flex;
      justify-content:space-between;
      align-items: center;
      font-size:12px;
      color:#aaa;
    }

    .input-with-button{
        width:10px;
      }
      .input-with-select{
        margin-right:10px;
      }
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
    .pro-lable{
        width:200px; 
        border:none;
      }
    .s-box{
      margin:10px;
      background-color:#fff;
      width:calc(50% - 20px);
      min-height: 300px;
    }
    .s-box-title{
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      border-bottom:1px solid #f1f1f1;
    }
    .s-box-title-label{
      font-size:14px;
      padding:10px 0px;
    }
    .s-box-title-label-title{
      margin:0px 10px 0px 0px;
    }
    .s-box-title-label-tag{
      display: flex;
      flex-direction: row;
      align-items:center;
    }
    .s-box-title-search{
      display: flex;
      flex-direction: row;
      justify-content:end;
      padding:10px 0px;

    }
    .sr-ui-container{
      height:calc(100% - 120px);
    }
    .sr-ui-container-body{
      height:100%;
    }
    .s-box2{
      position:relative;
      margin:10px;
      background-color:#fff;
      width:calc(100% - 50px);
      height:100%;
      min-height:500px;
      padding:5px 20px;
    }
    .page-pagination{
      position:absolute;
      bottom:10px;
      width:calc(100% - 50px);
      display: flex;
      justify-content: end;
    }
    .search-up-box{
      padding:10px;
      cursor: pointer;
    }
    .search-up-box:hover{
      background-color:#f9f9f9;
    }
    .search-down-box{
      padding:10px;
      cursor: pointer;
    }
    .search-down-box:hover{
      background-color:#f9f9f9;
    }
    .search-text-box{
      padding:20px 20px ;
      background-color:#f9f9f9;
      margin:10px 0px;
    }
    .search-button-box{
      display:flex;
      justify-content:end;
    }
    .boardTitle{

    }
    .boardTag{
      display:flex;
      flex-direction:column;
      padding:10px 0px  0px  0px;
    }
    .boardrow{
      display:flex;
      flex-direction:row;
      align-items:center;
      padding:10px 0px  0px  0px;
    }
    ::v-deep.el-autocomplete .el-popper{
        width: auto !important;
    }
    .el-collapse-item__content{
      padding-bottom:0px !important;
    }

    .marginTop20{
      margin-top:20px;
    }
    .marginTop5{
      margin-top:5px;
    }
    .dashboardIcon{
      font-size:20px;
      color:#409EFF;
      margin-right:5px;
    }
    .dashboardTitle{

      font-size:16px;
    }
    .dashboardIcon2{
      font-size:16px;
      color:#aaa;
      margin-right:5px;
    }
    .dashboard-desc{
       color:#f1f1f1;
    }

    .dashboardTitle2{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding:0px 0px 0px 0px;
      justify-content: space-between;

    }
    .exportTitle{
      padding:0px 0px 0px 20px;
    }
    

</style>




// WEBPACK FOOTER //
// src/pages/home.vue